import { Button, Divider, Form, Input, message, Modal } from "antd";
import * as COMMONS from "common/common";
import { TapAnimationComponent } from "components";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { useCopyToClipboard } from "react-use";

const { TextArea } = Input;

const MESSAGE_ATTRIBUTES = [
	{
		value: "BUILDING",
		label: "を入力すると、配信の時にイベント名に変換されます。",
	},
	{
		value: "NAME",
		label: "を入力すると、配信の時にお客様の名前に変換されます。",
	},
	{
		value: "DATE",
		label: "を入力すると、配信の時に予約の日付に変換されます。",
	},
	{
		value: "COMPANY-TEL",
		label: "を入力すると、配信の時に問い合わせ電話番号に変換されます。",
	},
];

const EventMessageModal = (props) => {
	const {
		isEventMessageModalVisible,
		hideEventMessageModal,
		currentCategoryMessageDetail,
		onSubmit,
	} = props;

	const [eventMessageForm] = Form.useForm();

	useEffect(() => {
		if (!isEventMessageModalVisible) {
			eventMessageForm.resetFields();
		}
	}, [isEventMessageModalVisible, eventMessageForm]);

	useEffect(() => {
		if (isEventMessageModalVisible) {
			eventMessageForm.setFieldsValue({
				afterReservationMessage:
					currentCategoryMessageDetail?.afterReservationMessage,
				reminderMessageThreeDays:
					currentCategoryMessageDetail?.reminderMessageThreeDays,
				reminderMessageOneDay:
					currentCategoryMessageDetail?.reminderMessageOneDay,
				winners: currentCategoryMessageDetail?.winners,
			});
		}

		// eslint-disable-next-line
	}, [isEventMessageModalVisible]);

	const handleEventMessage = (data) => {
		onSubmit(data);
		hideEventMessageModal();
	};

	const [, copyToClipboard] = useCopyToClipboard();

	const handleCopyToClipboard = (attribute) => {
		copyToClipboard(`[${attribute}]`);
		message.success(`[${attribute}]をコピーしました`);
	};

	const renderExtra = (attributes = []) => {
		return (
			<div className="flex flex-col">
				{attributes.map((attribute, key) => (
					<span
						key={key}
						onClick={() => handleCopyToClipboard(attribute.value)}
					>
						※メッセージに
						<span className="cursor-pointer">[{attribute.value}]</span>
						{attribute.label}
					</span>
				))}
			</div>
		);
	};

	return (
		<>
			<Modal
				open={isEventMessageModalVisible}
				onCancel={hideEventMessageModal}
				title="お客様通知設定"
				footer={null}
				styles={{
					body: {
						maxHeight: "90vh",
						overflowY: "auto",
						overflowX: "hidden",
					},
				}}
				maskClosable={false}
				width={720}
				destroyOnClose
				centered
			>
				<Form
					form={eventMessageForm}
					layout="vertical"
					initialValues={{
						afterReservationMessage: undefined,
						reminderMessageThreeDays: undefined,
						reminderMessageOneDay: undefined,
					}}
					onFinish={handleEventMessage}
					size="large"
					requiredMark={false}
					scrollToFirstError={COMMONS.FORM_SCROLL_CONFIG}
				>
					<motion.div
						variants={COMMONS.ANIMATION_VARIANT_STAGGER_CONTAINER}
						initial="hidden"
						animate="show"
						exit="hidden"
					>
						<motion.div
							variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}
							className="p-4 bg-yellow-300 rounded mb-8"
						>
							<span className="text-center">
								設定されてない場合は、メッセージが配信されません。
							</span>
						</motion.div>

						<Divider />
						<motion.div variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}>
							<Form.Item
								name="afterReservationMessage"
								label="予約後に配信されるメッセージ"
								extra={renderExtra(MESSAGE_ATTRIBUTES)}
							>
								<TextArea placeholder="メッセージを入力してください" autoSize />
							</Form.Item>
						</motion.div>
						<Divider />
						<motion.div variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}>
							<Form.Item
								name="reminderMessageThreeDays"
								label="リマインドメッセージ（予約より7日前に配信される）"
								extra={renderExtra(MESSAGE_ATTRIBUTES)}
							>
								<TextArea placeholder="メッセージを入力してください" autoSize />
							</Form.Item>
						</motion.div>
						<Divider />
						<motion.div variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}>
							<Form.Item
								name="reminderMessageOneDay"
								label="リマインドメッセージ（予約より1日前に配信される）"
								extra={renderExtra(MESSAGE_ATTRIBUTES)}
							>
								<TextArea placeholder="メッセージを入力してください" autoSize />
							</Form.Item>
						</motion.div>
						<Divider />
						<motion.div
							variants={COMMONS.ANIMATION_VARIANT_STAGGER_ITEM}
							className="flex justify-center"
						>
							<TapAnimationComponent>
								<Button
									type="primary"
									htmlType="submit"
									size="large"
									className="m-1 w-32"
								>
									保存する
								</Button>
							</TapAnimationComponent>
						</motion.div>
					</motion.div>
				</Form>
			</Modal>
		</>
	);
};

export default EventMessageModal;
